import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { confereNomeDaOrganizacao } from "@bookdental/schemas";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, Input, Label } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";

/** Última trava antes de agendar: digitar o nome da organização e a senha (ou o e-mail da conta). */
export function ConfirmarExclusaoDialog({
  aberto,
  nome,
  conta,
  onFechar,
}: {
  aberto: boolean;
  nome: string;
  conta: { email: string; temSenha: boolean };
  onFechar: () => void;
}) {
  const utils = trpc.useUtils();
  const [digitado, setDigitado] = useState("");
  const [segredo, setSegredo] = useState("");
  const fechar = () => {
    setDigitado("");
    setSegredo("");
    onFechar();
  };
  const agendar = trpc.organization.exclusao.agendar.useMutation({
    onSuccess: ({ prevista }) => {
      toast.success(`Exclusão agendada para ${new Date(prevista).toLocaleDateString("pt-BR")}. Até lá dá pra desfazer.`);
      fechar();
      utils.invalidate();
    },
    onError: (e) => toast.error(e.message),
  });
  const nomeConfere = confereNomeDaOrganizacao(digitado, nome);

  return (
    <Dialog open={aberto} onOpenChange={(v) => !v && fechar()}>
      <DialogContent className="max-w-md border border-zinc-200 bg-white shadow-xl dark:border-border dark:bg-card">
        <DialogHeader>
          <DialogTitle>Excluir {nome}?</DialogTitle>
          <DialogDescription>
            Por 7 dias ela fica só leitura e dá pra desfazer. Depois disso os dados são apagados e os membros saem — isso não tem volta.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="space-y-1.5">
            <Label htmlFor="excluir-nome">
              Digite <b>{nome}</b> para confirmar
            </Label>
            <Input id="excluir-nome" value={digitado} onChange={(e) => setDigitado(e.target.value)} autoComplete="off" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="excluir-segredo">{conta.temSenha ? "Sua senha" : `Digite o e-mail da conta (${conta.email})`}</Label>
            <Input id="excluir-segredo" type={conta.temSenha ? "password" : "email"} value={segredo} onChange={(e) => setSegredo(e.target.value)} />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={fechar} className="inline-flex h-9 items-center rounded-md border border-zinc-200 px-3 text-sm font-medium text-zinc-600 hover:bg-zinc-50 dark:border-border dark:text-foreground dark:hover:bg-muted">
            Cancelar
          </button>
          <button
            type="button"
            disabled={!nomeConfere || !segredo || agendar.isPending}
            onClick={() =>
              agendar.mutate({ nomeDaOrganizacao: digitado, ...(conta.temSenha ? { senha: segredo } : { emailDeConfirmacao: segredo }) })
            }
            className="inline-flex h-9 items-center gap-1.5 rounded-md bg-red-600 px-4 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50"
          >
            {agendar.isPending && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
            Excluir organização
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
